module.exports = __webpack_public_path__ + "static/media/smoking.6a56acd2.svg";